import { useEffect } from 'react';
import { useRouterParams } from 'src/hooks/utils';
import { useUser } from 'src/hooks/user';
import { useRoles } from 'src/hooks/role';
import { useFilteringRuleGroups } from 'src/hooks/filteringRuleGroup';
import { useActivityCreate } from 'src/hooks/activity';
import { useTimezones } from 'src/hooks/timezone';

export default match => {
  const { isNew, id } = useRouterParams(match);

  const { data = {}, loading: userLoading } = useUser(id, isNew);
  const { data: rolesData, loading: rolesLoading } = useRoles({
    limit: 1000,
    offset: 0,
    withDeleted: true,
  });
  const { data: timezonesData, loading: timezonesLoading } = useTimezones({
    limit: 1000,
    offset: 0,
  });
  const { data: filteringRuleGroupsData, loading: filteringRuleGroupsLoading } = useFilteringRuleGroups({
    limit: 1000,
    offset: 0,
    withDeleted: true,
  });

  const roles = (rolesData && rolesData.roles) || [];
  const filteringRuleGroups = (filteringRuleGroupsData && filteringRuleGroupsData.filteringRuleGroups) || [];
  const timezones = (timezonesData && timezonesData.timezones) || [];
  const user = data.user || { id };

  const createActivity = useActivityCreate();

  useEffect(() => {
    if (id) {
      createActivity({
        entityType: 'User',
        entityId: id,
        action: 'view',
      });
    }
  }, [id]);

  return {
    isNew,
    user,
    roles,
    filteringRuleGroups,
    timezones,
    loading: userLoading || rolesLoading || timezonesLoading || filteringRuleGroupsLoading,
  };
};
